import { ReactComponent as Arrow } from 'assets/arrowRight.svg'
import React, { useRef } from 'react'
import './style.scss'

interface ArrowBtnProps {
  text: string
  isLoading?: boolean
  className?: string
  showArrow?: boolean
  enlarged?: boolean
  disabled?: boolean
  isBlankButton?: boolean
  action: basic.BasicFunc
}

const ArrowBtn: React.FC<ArrowBtnProps> = ({ text, isLoading, className = '', isBlankButton = false, showArrow = true, enlarged = false, disabled = false, action }) => {
  const buttonRef = useRef<HTMLButtonElement>(null)
  return (
    <button
      type='button'
      title={text}
      ref={buttonRef}
      className={`button --${isBlankButton ? 'back' : 'arrow'}${enlarged ? ' --enlarged' : ''}${disabled ? ' --disabled' : ''} ${className}`}
      onClick={() => {
        const button = buttonRef.current
        if (!disabled && !isLoading && button) {
          button.className += ' --animate'
          setTimeout(() => {
            button.className = button.className.replace(' --animate', '')
            action()
          }, 200)
        }
      }}>
      {isLoading
        ? <i className='icon icon--loading' />
        : <>
          <span className={isBlankButton ? undefined : '--secFont'}>
            {text}
          </span>
          {showArrow && <Arrow />}
        </>}
    </button>
  )
}

export default ArrowBtn